export const PRIMARY_COLOR = "#0063FF";
